import React from 'react';

export function TitlePage({ title }) {
  return <h1 className="text-dark font-weight-bolder"> {title} </h1>;
}
